/**
 * AS-11272 — the cohort-routing fields of `/stores/detail`, read in one place.
 *
 * `frontend_app` says which app serves the store (M2 guard); it is `null`
 * when the bot has no row or could not read it, and the guard then stays put.
 * `frontend_app_opt_in_available` (M6) is computed by the bot FOR THE CALLING
 * TOKEN: true only for the store owner, while the C3 coverage gate is open and
 * the store is not on atlas yet. Warbler has no notion of "owner" on the
 * client, so it never derives this itself.
 */
export type FrontendApp = 'warbler' | 'atlas';

export interface FrontendAppFields {
  frontendApp: FrontendApp | null;
  optInAvailable: boolean;
}

export function parseFrontendAppFields(data: any): FrontendAppFields {
  const raw = data ? data.frontend_app : undefined;
  return {
    frontendApp: raw === 'warbler' || raw === 'atlas' ? raw : null,
    optInAvailable: !!data && data.frontend_app_opt_in_available === true,
  };
}
